<template>
  <template v-if="!step || step === 1">
    <div class="flex col-12 column">
      <span class="text-h6">Which Markets Are You Interested In?</span>
      <q-list
        :class="{'q-list-columns': $q.screen.gt.xs}"
      >
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.markets.US" />
          </q-item-section>
          <q-item-section>
            <q-item-label>United States</q-item-label>
            <q-item-label caption>
              <FlagIcon
                class="q-mr-sm q-pa-none"
                name="spf-flag-us"
                size="0.85rem"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.markets.CA" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Canada</q-item-label>
            <q-item-label caption>
              <FlagIcon
                class="q-mr-sm"
                name="spf-flag-ca"
                size="0.85rem"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.markets.EU" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Europe</q-item-label>
            <q-item-label caption>
              <FlagIcon
                class="q-mr-sm"
                name="spf-flag-eu"
                size="0.85rem"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.markets.CN" />
          </q-item-section>
          <q-item-section>
            <q-item-label>China</q-item-label>
            <q-item-label caption>
              <FlagIcon
                class="q-mr-sm"
                name="spf-flag-cn"
                size="0.85rem"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.markets.IN" />
          </q-item-section>
          <q-item-section>
            <q-item-label>India</q-item-label>
            <q-item-label caption>
              <FlagIcon
                class="q-mr-sm"
                name="spf-flag-in"
                size="0.85rem"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.markets.REST_AS" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Rest of Asia</q-item-label>
            <q-item-label caption>
              <FlagIcon
                name="spf-flag-jp"
                size="0.85rem"
              />
              <FlagIcon
                name="spf-flag-hk"
                class="q-ml-sm"
                size="0.85rem"
              />
              <FlagIcon
                name="spf-flag-my"
                class="q-ml-sm"
                size="0.85rem"
              />
              <FlagIcon
                name="spf-flag-sg"
                class="q-ml-sm -mr-sm"
                size="0.85rem"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </div>
  </template>
  <template v-if="!step || step === 2">
    <div class="flex col-12 column">
      <span class="text-h6">Which Financial Assets Are You Interested In?</span>
      <q-list
        :class="{'q-list-columns': $q.screen.gt.xs}"
      >
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.titleTypes.company" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Stocks</q-item-label>
            <q-item-label caption>
              <q-icon
                class="q-mr-sm"
                :name="getTitleTypeIcon('company')"
                size="xs"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.titleTypes.index" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Indices</q-item-label>
            <q-item-label caption>
              <q-icon
                class="q-mr-sm"
                :name="getTitleTypeIcon('index')"
                size="xs"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.titleTypes.raw_material" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Commodities</q-item-label>
            <q-item-label caption>
              <q-icon
                class="q-mr-sm"
                :name="getTitleTypeIcon('raw_material')"
                size="xs"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.titleTypes.crypto_currency" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Cryptocurrencies</q-item-label>
            <q-item-label caption>
              <q-icon
                class="q-mr-sm"
                :name="getTitleTypeIcon('crypto_currency')"
                size="xs"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.titleTypes.forex" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Currencies</q-item-label>
            <q-item-label caption>
              <q-icon
                class="q-mr-sm"
                :name="getTitleTypeIcon('forex')"
                size="xs"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          tag="label"
          v-ripple
        >
          <q-item-section avatar>
            <q-checkbox v-model="uiPreferences.titleTypes.fund" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Funds</q-item-label>
            <q-item-label caption>
              <q-icon
                class="q-mr-sm"
                :name="getTitleTypeIcon('fund')"
                size="xs"
              />
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </div>
  </template>
</template>

<script setup lang="ts">
import { defineProps, PropType, Ref } from 'vue'
import { getTitleTypeIcon } from 'src/helper/EntityHelper'
import { UiPreferencesGUI } from 'stores/inventory-store'
import FlagIcon from 'components/FlagIcon.vue'

export interface UserPreferenceFormProps {
  step?: number
}

defineProps<UserPreferenceFormProps>()

const uiPreferences : Ref<UiPreferencesGUI> = defineModel('uiPreferences', {
  type: Object as PropType<UiPreferencesGUI>,
  required: true
})

</script>

<style scoped>
.q-list-columns {
  display: flex;
  flex-wrap: wrap;
}

.q-item {
  flex: 1 1 calc(50% - 10px);
  box-sizing: border-box;
  padding: 0
}
</style>
